import React from 'react';
import { useNavigate } from "react-router-dom";
import {ArrowRight} from "lucide-react";
import heroImage from "../../assets/fotofrenteoverlay.png"

const HeroSection = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate("/acervo"); 
  };

  const handleVisitClick = () => {
    const visitSection = document.getElementById("plan-visit-section");
    if (visitSection) {
      visitSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <section className="hero-section">
      <div
        className="hero-background"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
        <h1>Centro de Memória e Museu Histórico de Medicina FMRP - USP</h1>
        <p>
          Preservação e difusão da memória Institucional e científica 
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={handleExploreClick}>
            Explorar Acervo
            <ArrowRight className="icon" />
          </button>
          <button className="btn btn-outline" onClick={handleVisitClick}>Visite-nos</button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;